
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 47.4 131.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"23.7","cy":"27","r":"10"}}),_c('path',{attrs:{"d":"M11.3 73.8l-.7 51c0 3.3 2.7 6 6 6s6-2.7 6-6v-41h2.3v40.8c0 3.3 2.7 6 6 6s6-2.7 6-6l-.7-51H11.3v.2z"}}),_c('path',{attrs:{"d":"M46.6 61.5c-.6-5.8-1.8-12-5.1-16.9-1.2-1.7-2.7-3.2-3.9-4.2-.9-.8-2.1-1.2-3.3-1.2H17.2c-3.7 0-7-2.5-8-6-1-3.6-1.5-6.7-1.8-9.1-.4-3.3-.4-4.9-.3-7.3.1-4.2.7-8.4 1.8-12.5.4-1.6-.4-3.4-1.9-4C6.6.1 6.2 0 5.7 0 4.3 0 2.9 1 2.5 2.5.6 9.8.1 17.3.8 24.7c.6 5.8 1.8 12 5.1 16.9 0 0 0 .1.1.1 3.4 4.9 5.3 10.7 5.3 16.7v13.2H36V47.3s.1-.1.1 0c2.4 6.1 3.4 11.3 3.8 14.9.4 3.3.4 4.9.3 7.3-.1 4.2-.7 8.3-1.7 12.5-.4 1.6.4 3.4 1.9 4 .4.2.9.3 1.3.3 1.5 0 2.8-1 3.2-2.5 1.9-7.4 2.4-14.8 1.7-22.3z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M22.7 54.1H20v-1.9h2.7v-2.6h1.9v2.6h2.7v1.9h-2.7v2.6h-1.9v-2.6z"}})])
          )
        }
      }
    